<template>
  <div class="search">
    <blank-card v-loading="loading">
      <div v-if="count > 0" class="search-header">
        <h3 class="search-title">
          {{ $t('search.totalConcepts') }} ({{ count }})
        </h3>
      </div>
      <div v-if="count == 0" class="search-header">
        <div class="header-main">
          <div class="main-icon">
            <img src="@/common/image/concept/not-result.svg" alt="" srcset="" />
          </div>
          <h3>{{ $t('search.notResult') }}</h3>
          <p>{{ $t('search.notResultDes') }}</p>
        </div>
      </div>
      <div v-if="count > 0" class="search-list">
        <el-card
          v-for="(item, index) in results"
          :key="index"
          shadow="hover"
          class="search-item"
        >
          <div @click="goConceptDetail(item.ui)">
            <div class="search-item-title">
              <div class="concept-name">
                <a v-html="item.translatedLabel"></a>
              </div>
              <div class="concept-ui">
                <span>{{ item.ui }}</span>
              </div>
            </div>
            <div class="search-item-syno">
              <span class="search-item-syno-name">
                {{ $t('common.synonyms') }}
              </span>
              <span
                class="search-item-syno-content"
                v-html="
                  item.synonyms.join(', ').replace(/#FF810D/gi, '#0ca1bd')
                "
              ></span>
            </div>
            <div class="search-item-intro">
              <div class="search-item-intro-main">
                <div class="search-item-intro-item">
                  <label>{{ $t('common.definition') }}</label>
                  <span>{{ item.definition }}</span>
                </div>
                <div class="search-item-intro-item">
                  <label>{{ $t('common.semanticTypes') }}</label>
                  <span>{{ item.semanticTypes.join(', ') }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </blank-card>
  </div>
</template>

<script lang="ts">
import { search } from '@/api'
import { AtomResult, ConceptResult } from '@/api/type'
import { defineComponent } from 'vue'
import BlankCard from '@/components/blankCard/index.vue'
import router from '@/router'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: {
    BlankCard,
  },
  beforeRouteUpdate(to, from) {
    if (to.fullPath !== from.fullPath) {
      this.results = []
      this.page = 1
      this.conceptSearchLoad(to.params.query as string)
      localStorage.setItem('lastQuery', to.params.query as string)
    }
  },
  beforeRouteLeave() {
    window.removeEventListener('scroll', this.scrollBottom) //页面离开后销毁监听事件
  },
  data: () => ({
    page: 1 as number,
    count: 0 as number,
    results: [] as (ConceptResult | AtomResult)[],
    loading: true as boolean,
    finite: false as boolean,
    store: useStore(),
    route: useRoute(),
  }),
  created() {
    window.addEventListener('scroll', this.scrollBottom) //注册监听滚动条事件
  },

  methods: {
    initSeachName() {
      const conceptName = this.route.params.query as string
      ;(
        document.getElementsByClassName(
          'el-input__inner'
        )[1] as HTMLInputElement
      ).value = decodeURIComponent(conceptName)
    },

    goConceptDetail(ui: string) {
      router.push(
        `/conceptDetail/${ui}/${this.route.params.name}/${this.route.params.type}`
      )
    },

    async conceptSearchLoad(routerQuery: string | null = null) {
      this.loading = true
      const query = routerQuery || (this.$route.params.query as string)
      if (routerQuery) {
        this.finite = false
      }
      if (this.finite || !query) {
        this.loading = false
        return
      }

      if (this.loading) {
        const { count, searchResultItemList: results } = await search(
          query,
          this.page
        )
        this.loading = false

        results.forEach((item) => {
          item.highlightedLabel = item.highlightedLabel.replace(
            /#FF810D/gi,
            '#0ca1bd'
          )
          item.translatedLabel = item.highlightedLabel
            ? item.highlightedLabel
            : item.label
        })
        this.results = [...this.results, ...results]

        this.count = count

        if (count === 0 || this.results.length >= count) {
          this.finite = true
        }

        this.loading = false
        this.page += 1
      }
    },
    scrollBottom() {
      if (this.finite || this.loading || this.results.length === 0) return
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.conceptSearchLoad()
      }
    },
  },
  mounted() {
    this.conceptSearchLoad()
    this.initSeachName()
    localStorage.setItem('lastQuery', this.route.params.query as string)
  },
})
</script>

<style lang="less" scoped>
.search {
  display: flex;
  margin: 0 auto;
  background-color: #fff;
  .container {
    width: 1200px;
    margin-top: 10px;
    margin-bottom: 200px;
    background-color: #fff;
  }
  &-header {
    flex: 1;
    padding-top: 10px;
    padding-left: 20px;
    .header-main {
      width: 420px;
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      .main-icon {
        width: 109px;
        height: 80px;
        margin: 10% auto 0;
      }
      h3 {
        margin: 30px auto;
        font-weight: 700;
        font-size: 24px;
        line-height: 28px;
        color: #303133;
      }
      p {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        color: #606266;
      }
    }
  }
  &-title {
    font-size: 20px;
    line-height: 32px;
  }
  &-list {
    padding: 0px 24px;
  }
  &-item {
    margin: 20px 0;
    a {
      font-size: 20px;
      font-weight: bold;
      color: #303133;
      font-size: 22px;
    }
    .concept-ui {
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      color: #444444;
    }
    &-syno {
      font-family: 'Roboto';
      font-style: normal;
      &-name {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #777;
      }
      &-content {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #444444;
      }
    }
    &-intro {
      display: flex;
      margin-top: 10px;
      font-size: 14px;
      line-height: 20px;
      label {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: #777;
      }
      span {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #444444;
      }
    }
    &-title {
      display: flex;
      justify-content: space-between;
    }
    &-syno {
      border-bottom: 1px solid #e5e5e5;
      line-height: 35px;
      &-name {
        font-weight: bold;
        margin-right: 5px;
      }
    }
  }
  .el-card.is-always-shadow,
  .el-card.is-hover-shadow:focus,
  .el-card.is-hover-shadow:hover {
    box-shadow: 0 0 10px #aa9999;
    transform: scale(1.01);
  }
}
.mobile-viewport {
  .concept-name {
    line-height: 20px;
    a {
      font-size: 18px;
    }
  }
  .concept-ui a {
    font-size: 15px;
  }
  .search-item-syno {
    font-size: 14px;
    line-height: 25px;
  }
}
</style>
